// Mock data for Sympozium website

export const testimonials = [
  {
    id: 1,
    name: "Anita Pandey",
    role: "Lost 35 lbs in 4 months",
    text: "Sympozium didn't just help me lose weight—they taught me how to live a healthier life. The personalized approach made all the difference.",
    rating: 5
  },
  {
    id: 2,
    name: "Maya Patel",
    role: "Lost 15 lbs",
    text: "The science-backed training and nutrition guidance transformed my body and mindset. Best investment I've made in myself.",
    rating: 5
  },
  {
    id: 3,
    name: "Raj Verma",
    role: "Lost 28 lbs, kept it off",
    text: "What I love most is the sustainability. This isn't a crash diet—it's a lifestyle change that actually works.",
    rating: 5
  },
  {
    id: 4,
    name: "Aniketh P",
    role: "Lost 42 lbs in 6 months",
    text: "The accountability and personalized coaching kept me on track. I've never felt stronger or more confident.",
    rating: 5
  }
];

export const transformations = [
  {
    id: 1,
    image: "/images/before 1.jpg",
    name: "Before",
    result: "77 Kg"
  },
  {
    id: 2,
    image: "/images/after 1.jpg",
    name: "After",
    result: "63 Kg"
  },
  {
    id: 3,
    image: "/images/before 2.jpg",
    name: "Before",
    result: "82 Kg"
  },
  {
    id: 4,
    image: "/images/after 2.jpg",
    name: "After",
    result: "60 Kg"
  }
];

export const services = [
  {
    id: 1,
    title: "1:1 Personal Training",
    description: "Custom workouts designed for your body, goals, and lifestyle. Experience personalized attention and expert guidance every step of the way.",
    features: [
      "Customized workout programs",
      "Weekly progress tracking",
      "Form correction & technique coaching",
      "Flexible scheduling"
    ],
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b"
  },
  {
    id: 2,
    title: "Online Coaching",
    description: "Train anywhere with expert guidance and progress tracking. Get the same results with the flexibility to work out on your schedule.",
    features: [
      "Custom training plans",
      "Video form reviews",
      "Weekly check-ins"
    ],
    image: "https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3"
  },
  {
    id: 3,
    title: "Nutrition & Lifestyle Guidance",
    description: "Simple, sustainable meal plans for lasting results. Learn how to fuel your body properly without restrictive dieting.",
    features: [
      "Personalized meal planning",
      "Macro tracking guidance",
      "Lifestyle habit coaching",
      "Recipe suggestions"
    ],
    image: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5"
  }
];

export const stats = [
  {
    id: 1,
    number: "50+",
    label: "Clients Transformed"
  },
  {
    id: 2,
    number: "5+",
    label: "Years Experience"
  },
  {
    id: 3,
    number: "100%",
    label: "Success Rate"
  },
  {
    id: 4,
    number: "500+",
    label: "Kgs Lost Collectively"
  }
];